export {
    INLINEIMAGE_CUSTOM_DATA_TEMPLATE,
    INLINEIMAGE_URL_ONLOAD_TEMPLATE,
    INLINEIMAGE_URL_TEMPLATE,
    INLINEIMAGE_ATTRIBUTE_DATA_CUSTOM,
    INLINEIMAGE_ATTRIBUTE_ORIGINALSRC,
    INLINEIMAGE_ATTRIBUTE_LOADSTATUS,
    INLINEIMAGE_ATTRIBUTE_VALUE_PENDING,
} from './schema/InlineImageServiceConsts';
